import request from '@/utils/request'

export function findModuleGoods(params) {
  return request({
    url: `/customer/module_goods`,
    method: 'get',
    params
  })
}

export function findModuleGoodsInfo(id, params) {
  return request({
    url: `/customer/module_goods/${id}`,
    method: 'get',
    params
  })
}
